import { getIsPagesV4OrV5Active } from './functions';

export function rowListLength(rows) {
  if (!rows) return 0;
  if (typeof rows.size === 'number') return rows.size;
  if (Array.isArray(rows)) return rows.length;
  return 0;
}

export function pickCarouselInfoList(page) {
  if (!page) return undefined;
  const elements = page.get?.('elements') ?? page.elements;
  const carousels = page.get?.('carousels') ?? page.carousels;
  if (getIsPagesV4OrV5Active()) {
    if (rowListLength(elements) > 0) return elements;
    return carousels ?? elements;
  }
  if (rowListLength(carousels) > 0) return carousels;
  return carousels ?? elements;
}
